module.exports = __webpack_public_path__ + "img/yiyao_jilinguanjie_suoluetu.5b5baf24.png";